import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './adhaarOTP.css';

const AadhaarOtp = () => {
  const [aadhaarNumber, setAadhaarNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpMeta, setOtpMeta] = useState(null); // To store request_id, task_id, group_id
  const [response, setResponse] = useState(null);

  const handleRequestOtp = async () => {
    try {
      Swal.fire({
        title: 'Sending OTP...',
        text: 'Please wait while we request OTP for the provided Aadhaar number.',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const headers = {
        'app-id': 'IDV-Client-Ribbon',
        'Content-Type': 'application/json'
      };

      const data = {
        aadhaarNumber,
        consent: "Y",
        consentText: "I hear by declare my consent agreement for fetching my Aadhaar information"
      };

      const result = await axios.post('https://idv.myearth.id/request-otp', data, { headers });
      setOtpMeta({
        request_id: result.data.request_id,
        task_id: result.data.task_id,
        group_id: result.data.group_id
      });

      Swal.fire({
        icon: 'success',
        title: 'OTP Sent Successfully',
        text: 'An OTP has been sent to your registered mobile number.'
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed to Send OTP',
        text: error.response.data.message || 'Something went wrong while requesting OTP.'
      });
    }
  };

  const handleVerifyOtp = async () => {
    try {
      if (!otpMeta.request_id || !otpMeta.task_id) {
        Swal.fire({
          icon: 'error',
          title: 'Missing Data',
          text: 'Request ID or Task ID is missing from the OTP response.'
        });
        return;
      }

      Swal.fire({
        title: 'Verifying OTP...',
        text: 'Please wait while we verify the entered OTP.',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const headers = {
        'app-id': 'IDV-Client-Ribbon',
        'Content-Type': 'application/json'
      };

      const data = {
        requestId: otpMeta.request_id,
        otp,
        consent: "Y",
        consentText: "I hear by declare my consent agreement for fetching my information from my Aadhaar",
        taskId: otpMeta.task_id
      };

      const result = await axios.post('https://idv.myearth.id/verify-otp', data, { headers });
      setResponse(result.data);

      Swal.fire({
        icon: 'success',
        title: 'Verification Successful',
        text: 'Your Aadhaar OTP has been verified successfully.'
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'OTP Verification Failed',
        text: error.response.data.message || 'Something went wrong during OTP verification.'
      });
    }
  };

  return (
    <div className="containerev">
      <div className="wrapper">
        <div className="left-pane">
          <h3>Aadhaar Verification</h3>
          <div className='instext'>
            <p>Fill in the below details to run verification</p>
          </div>
          <div className="input-container">
            <label className="input-label">Aadhaar Number</label>
            <input
              type="text"
              placeholder="Enter Aadhaar Number"
              value={aadhaarNumber}
              onChange={(e) => setAadhaarNumber(e.target.value)}
            />
            <button onClick={handleRequestOtp}>Send OTP</button>
          </div>

          {otpMeta && (
            <div className="input-container">
              <label className="input-label">OTP</label>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <button onClick={handleVerifyOtp}>Run Verification</button>
            </div>
          )}
        </div>

        <div className="linee"></div>

        <div className="right-pane">
          <h3>Verification Data</h3>
          {(otpMeta || response) && (
            <div className="response-container">
              {/* Display OTP meta */}
              {otpMeta && !response &&(
                <>
                  <div className="detail-row">
                    <div className="label">request_id</div>
                    <div className="value">{otpMeta.request_id}</div>
                  </div>
                  <div className="detail-row">
                    <div className="label">task_id</div>
                    <div className="value">{otpMeta.task_id}</div>
                  </div>
                  <div className="detail-row">
                    <div className="label">group_id</div>
                    <div className="value">{otpMeta.group_id}</div>
                  </div>
                  <hr />
                </>
              )}

              {/* Profile + Image */}
              {response && (
                <div className="profile-header">
                  <div className="name">{response.result.user_full_name}</div>
                  {response.result.user_profile_image && (
                    <img
                      src={`data:image/jpeg;base64,${response.result.user_profile_image}`}
                      alt="Profile"
                    />
                  )}
                </div>
              )}

{response && (
  [
    { label: 'user_full_name', value: response.result.user_full_name },
    { label: 'user_aadhaar_number', value: response.result.user_aadhaar_number },
    { label: 'user_dob', value: response.result.user_dob },
    { label: 'user_gender', value: response.result.user_gender },
    { label: 'house', value: response.result.user_address.house },
    { label: 'state', value: response.result.user_address.state },
    { label: 'country', value: response.result.user_address.country },
    { label: 'address_zip', value: response.result.address_zip },
    { label: 'user_parent_name', value: response.result.user_parent_name },
  ].map(
    ({ label, value }) =>
      value !== undefined && (
        <div className="detail-row" key={label}>
          <div className="label">{label}</div>
          <div className="value">{value}</div>
        </div>
      )
  )
)}

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AadhaarOtp;
